// ADD API URLS BELOW
export const API_URLS = {
    newsletterSignup: '/api/newsletter/signup',
    resourceListing: '/api/resource',
    articleListing: '/api/articles',
    helpListing: '/api/help',
    searchSubmit: '/api/search/submit',
    searchTypeahead: '/api/search/typeahead',
    searchResults: '/api/search/results',
};
